import axios from 'axios';
import { fixedNumber } from '../helpers/balanceHelpers';
import { ENDPOINTS } from '../constants';
import { IGetTransaction, ITransaction } from '../types/IWallet';

export interface IGetWallet {
    userId: string;
}

export const getWallet = async (params: IGetWallet) => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.wallet}/${params.userId}`);
    return (
        res.data && {
            currentValue: fixedNumber(res.data.currentValue),
        }
    );
};

export const getTransactions = async (params: IGetTransaction): Promise<ITransaction[]> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.transactions}/${params.userId}`, {
        params: {
            pageNumber: params.pageNumber,
            pageSize: params.pageSize,
        },
    });
    return (
        res.data &&
        res.data.entities &&
        res.data.entities.map((transaction: ITransaction) => ({
            ...transaction,
            amount: fixedNumber(transaction.amount),
        }))
    );
};

export const paypalCreateOrder = async (amount: number) => {
    const nowUrl = window.location.href;
    const returnUrl = `${nowUrl.split('/account')[0]}/account/?`;
    const res = await axios.post(
        `${axios.defaults.baseURL}${ENDPOINTS.paypalCreateOrder}?value=${amount}&returnUrl=${returnUrl}`
    );
    return res.data;
};
//
// export const withdrawCreateOrder = async (params) => {
//     const res = await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.withdrawCreateOrder}`, params);
//     return res.data;
// };
